import React, { type InputHTMLAttributes } from "react";
import { Field, type Validator } from "redux-form";
import type IFormInputs from "./IFormInputs";
import InputRenderer from "src/shared/forms/formrenderers/InputRenderer";
import { combineReduxFormValidationRules } from "src/shared/forms/validations/combineReduxFormValidationRules";
import { required as Required } from "src/shared/forms/validations/Required";

export interface IPasswordInputProps
  extends IFormInputs,
    InputHTMLAttributes<HTMLInputElement> {
  validations?: Validator | Validator[];
}

export default (props: IPasswordInputProps) => {
  const {
    inputID,
    label = null,
    validationDisabled,
    validations,
    ...rest
  } = props;
  return (
    <Field
      name={inputID}
      label={label}
      type="password"
      component={InputRenderer}
      validate={
        !validationDisabled
          ? combineReduxFormValidationRules(Required, validations)
          : undefined
      }
      {...rest}
    />
  );
};
